var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "news_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.5 7.5v14.375h10V56.5h-59v-49zm-45 45h51V25.875h-6V48.25h-4V11.5h-41zM40.125 40v4h-26.25v-4zm.125-22.5v14h-26.5v-14zm-22.5 10h18.5v-6h-18.5z"
  })));
};
export { SvgNews as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNTEuNSA3LjVWMjEuODc1SDYxLjVWNTYuNUgyLjVWNy41SDUxLjVaTTYuNSA1Mi41SDU3LjVWMjUuODc1SDUxLjVWNDguMjVINDcuNVYxMS41SDYuNVY1Mi41Wk00MC4xMjUgNDBWNDRIMTMuODc1VjQwSDQwLjEyNVpNNDAuMjUgMTcuNVYzMS41SDEzLjc1VjE3LjVINDAuMjVaTTE3Ljc1IDI3LjVIMzYuMjVWMjEuNUgxNy43NVYyNy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";